import gql from 'graphql-tag'
import { EntityFields } from '..'
import { PersonAddressFragment, PersonFragment } from '@/graphql/fragments/persons'

export const BaseDocumentIntervenerFragment = gql`
  fragment BaseDocumentIntervener on documents_intervener{
    ${EntityFields}
  }
`

export const DocumentIntervenerFragment = gql`
  ${BaseDocumentIntervenerFragment}
  ${PersonFragment}
  ${PersonAddressFragment}
  fragment DocumentIntervener on documents_intervener{
    ...BaseDocumentIntervener
    person {
      ...Person
      addresses(where: {active: {_eq:true}}) {
        ...PersonAddress
      }
    }
    field{
      id
      name
    }
    personAddress: person_address {
      id
    }
  }
`
